import { render, staticRenderFns } from "./mustericiroveiskonto.vue?vue&type=template&id=2f4ef38a&"
import script from "./mustericiroveiskonto.vue?vue&type=script&lang=js&"
export * from "./mustericiroveiskonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports